<template>
  <div class="content-wrappper">
    <div class="support-container row m-0">
      <div class="col-xs-12 mb-15">
        <router-link class="sub-link" to="/layout/dashboard">
          <img src="/static/images/icons/chevron_left.svg" alt="chevron-icon" />Help and Support
        </router-link>
      </div>
      <div class="col-xs-12 sub-heading mb-20">
        Feel free to drop us a message or search our comprehensive knowledge base.
      </div>
      <div class="col-xs-12">
        <div class="row mb-30">
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">Subject</div>
            <input
              type="text"
              placeholder="Enter Subject"
              class="form-control"
              v-model.trim="support.subject"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row mb-30">
          <div class="col-xs-12 col-sm-6 custom-dropdown">
            <div class="form-group">Service/Area</div>
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :class="!support.service ? 'un-selected' : ''"
              :searchable="false"
              :options="services"
              v-model="support.service"
              placeholder="Select Service/Area"
            >
            </multiselect>
          </div>
        </div>
        <div class="row mb-30">
          <div class="col-xs-12 col-sm-12">
            <div class="form-group">Message</div>
            <textarea
              type="text"
              placeholder="How can we help?"
              class="form-control text-box"
              v-model.trim="support.message"
              height="440px"
            />
          </div>
        </div>
        <div class="row mb-10">
          <div class="col-xs-12 col-sm-6 col-lg-5">
            <input type="file" ref="file" name="" id="custom-file" @change="fileChange" />
            <label for="custom-file">
              <base-tooltip
                class="item"
                selector=".support-container"
                content="PDF, Excel, PPT, DOC, Image file types accepted"
              >
                <div class="cursor-pointer">
                  <img
                    src="/static/images/icons/attachment_icon_blue.svg"
                    class="attachment-icon"
                    alt="attachment-icon"
                  /><span class="attachment-label text-emergo-dark-blue">Add an Attachment</span>
                </div>
              </base-tooltip>
            </label>
            <div class="file-success" v-if="file">
              <span>{{ file.name }}</span>
              <img
                class="cursor-pointer"
                src="/static/images/icons/close_icon.svg"
                width="14px"
                @click="resetFile()"
                alt="close-icon"
              />
            </div>
            <!-- <el-upload
              class="upload-demo"
              :file-list="fileList"
              action=""
              :auto-upload="false"
              :on-change="fileChange"
              accept=".pdf, .doc, .docx, .jpg, .tif, .gif, .png, .xlsx, .xls, .ppt, .pptx"
            >
              <el-tooltip
                class="item"
                effect="light"
                content="PDF, Excel, PPT, Doc, image file types accepted."
                placement="bottom-start"
              >
                <div class="el-upload__text">
                  <img
                    src="/static/images/icons/attachment_icon_blue.svg"
                    class="attachment-icon"
                    alt="attachment-icon"
                  /><span class="attachment-label text-emergo-dark-blue"
                    >Add an Attachment</span
                  >
                  <div class="file-error" v-if="showError">{{showError}}</div>
                </div>
              </el-tooltip>
            </el-upload> -->
          </div>
        </div>
        <div class="mb-10">
          <div class="file-error" v-if="showError">{{ showError }}</div>
        </div>
        <div class="row mb-30">
          <div
            class="col-md-3 col-md-offset-6 col-sm-offset-4 col-sm-4 col-xs-6 col-lg-offset-8 col-lg-2"
          >
            <router-link to="/layout/dashboard" class="btn btn-block emergo-white-button">
              Cancel
            </router-link>
          </div>
          <div class="col-md-3 col-sm-4 col-xs-6 col-lg-2">
            <button
              type="button"
              class="btn btn-block emergo-green-button"
              @click="sendSupportMessage"
            >
              Send
            </button>
          </div>
        </div>
        <div class="row border-top center pt-25">
          <span class="attachment-label">
            If you would like to, please contact
            <a
              href="mailto:ramshelp@ul.com"
              v-if="support.service != 'Smart Builder' && support.service != 'Smart Exchange'"
              >RAMShelp@ul.com.</a
            >
            <a v-else href="mailto:LST.Global.RAMShelp-SBSX@ul.com"
              >LST.Global.RAMShelp-SBSX@ul.com.</a
            ></span
          >
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import Loader from '../UIComponents/Loader.vue';
import { getUserData } from '../../apis/profile';
import { postSupportForm } from '../../apis/dashboard';
import BaseTooltip from '../Common/BaseTooltip.vue';

export default {
  data() {
    return {
      support: {
        subject: '',
        service: '',
        message: '',
        user_name: '',
        email: '',
        account_id: '',
        user_id: ''
      },
      loaderStatus: false,
      file: null,
      services: [
        'Account Settings/Users/Preferences',
        'Marketplace/Purchasing',
        'Smart Builder',
        'Smart Exchange',
        'Registration Tracker',
        'Regulatory Watch',
        'Notifications',
        'Regulations & Guidances',
        'Representation Resources',
        'Tools',
        'Product Classification',
        'Regulatory Reports',
        'Other/Not Listed'
      ],
      showError: '',
      fileTypes: [
        'pdf',
        'doc',
        'docx',
        'jpg',
        'tif',
        'gif',
        'png',
        'xlsx',
        'xls',
        'ppt',
        'pptx',
        'csv'
      ],
      fileCopy: null
    };
  },
  components: { Loader, BaseTooltip },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    async sendSupportMessage() {
      if (!this.support.subject || !this.support.message || !this.support.service) {
        this.showError = 'Please enter all required fields';
        return;
      }
      this.loaderStatus = true;
      this.support.message = this.support.message.replaceAll('\n', '<br>');
      const response = await postSupportForm(this.file, this.support);
      if (response && response.status_code === 200 && response.message === 'success') {
        this.loaderStatus = false;
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Successfully Sent',
          text: 'Our Support Team will reach out shortly',
          group: 'custom-notification'
        });
        this.$router.push('/layout/dashboard');
      } else {
        this.loaderStatus = false;
        this.clearNotifications();
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Message was not sent. Please refresh and try again.',
          group: 'custom-notification'
        });
      }
    },
    fileChange() {
      this.file = null;
      let [file] = this.$refs.file.files;
      if (file) {
        this.fileCopy = file;
      }

      if (file === undefined) {
        file = this.fileCopy;
      }
      const fileType = file?.name.split('.').pop().toLowerCase();
      if (file && !this.fileTypes.includes(fileType)) {
        this.showError =
          'Please choose types .pdf, .doc, .docx, .jpg, .tif, .gif, .png, .xlsx, .xls, .ppt, .pptx, .csv';
        return;
      }
      if (file && Math.round(file.size / 1024) > 20 * 1024) {
        this.showError = 'File size exceeds maximum limit 20 MB';
        return;
      }
      this.showError = '';
      this.file = file;
    },
    resetFile() {
      this.$refs.file.value = '';
      this.file = null;
    }
  },
  async created() {
    const userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
    this.support.email = userData.email;
    this.support.user_name = `${userData.first_name} ${userData.last_name}`;
    this.support.account_id = userData.account_id;
    this.support.user_id = userData.id;
  }
};
</script>
<style scoped>
.support-container {
  padding: 25px 15px 0;
  color: rgba(0, 0, 0, 0.7);
}
.mb-30 {
  margin-bottom: 30px;
}
.pt-25 {
  padding-top: 20px;
}
.sub-link > img {
  vertical-align: top;
  margin-top: 4px;
}
.sub-link {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 28px;
  cursor: pointer;
  color: #0b3c61;
}
.sub-heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  line-height: 28px;
}
.form-group {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
}
.form-control {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  background: #ffffff;
  border: 0.8px solid #828282;
  border-radius: 3px;
  display: block;
  width: 100%;
  height: 36px;
  padding: 7px 20px 7px 16px;
}
.form-control.text-box:focus-visible {
  padding-top: 6px;
}
.form-control:focus-visible {
  outline: none;
  padding-left: 15px;
  border: 2px solid #828282;
}
.attachment-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
.attachment-icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  vertical-align: sub;
}
.support-container textarea.form-control {
  min-height: 300px;
}
::v-deep .custom-dropdown .el-input__inner {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  border: 0.5px solid #828282 !important;
  border-radius: 20px;
}
::v-deep .custom-dropdown .el-select {
  width: 100%;
}
.border-top {
  border-top: 1px solid #d3d6d9;
}
input[type='file'] {
  display: none;
}
.file-error {
  color: #b00505;
  font-size: 14px;
}
.file-success {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  padding: 3px 5px;
  background: #efefef;
  border-radius: 4px;
}
.file-success img {
  width: 14px;
  height: 14px;
  margin: auto 0;
}
@media screen and (max-width: 767px) {
  .support-container {
    padding: 25px 0;
  }
}
</style>
